module.exports = __webpack_public_path__ + "img/figure-19.eee89cc0.png";